// extracted by mini-css-extract-plugin
export var progressBar = "_jy-0";
export var progressBarInner = "_jy-1";